module.exports = __webpack_public_path__ + "img/l_r_video_1_splash.5d92539c.jpg";